import { render, staticRenderFns } from "./ToufangGamePermission.vue?vue&type=template&id=5ababc88&scoped=true&"
import script from "./ToufangGamePermission.vue?vue&type=script&lang=js&"
export * from "./ToufangGamePermission.vue?vue&type=script&lang=js&"
import style0 from "./ToufangGamePermission.vue?vue&type=style&index=0&id=5ababc88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ababc88",
  null
  
)

export default component.exports